<template>
  <div class="page-loader">
    <div class="circle" />
    <h1 class="load-message">Redirecting..</h1>
  </div>
</template>

<script>
import Auth from '@/helpers/auth'
import redirectMixin from '@/mixins/redirects'

export default {
  name: 'Complete',
  metaInfo: {
    title: `Finishing Registration.. - ${process.env.VUE_APP_PAGE_TITLE}`
  },
  mixins: [redirectMixin],
  mounted () {
    const currentUser = this.$store.getters['users/currentUser']
    if (currentUser && typeof currentUser._id !== 'undefined') {
      this.$store.dispatch('users/GET_USER', this.$store.getters['users/currentUser']._id).then(res => {
        const user = res.data.users[0]
        Auth.saveUser(user)
        this.$store.commit('users/saveCurrentUser', user)
        this.$router.push({ name: 'participant-dashboard' })
      })
    } else {
      this.$store
        .dispatch('auth/LOGIN_USER', {
          email: this.$store.getters['register/email'],
          password: this.$store.getters['register/password']
        })
        .then(res => {
          if ('error' in res.data) {
            this.$toasted.error(res.data.error)
          } else {
            Auth.saveTokens(res.data)
            Auth.setHeader(this, res.data.token)
            Auth.saveUser(res.data.user)

            this.$store.commit('users/saveCurrentUser', res.data.user)

            this.redirectUser(res.data.user)
          }
        })
        .catch(err => {
          console.log(err)
          this.$toasted.error('Server error')
        })
    }
  }
}
</script>
